const initialState = {
    baseUrlSensotoAI: ''
  };
  
  const baseUrlSensotoAIReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_BASE_URL_STEPONE_WS':
            return { ...state, baseUrlSensotoAI: action.payload };
        default:
            return state;
    }
  };
  
  export default baseUrlSensotoAIReducer;
  